export default () => ({
    roles: [],
    defaults: [],
    loading: false
})
